<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                Areas & Groups
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-primary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Add area and group"
              :href="$router.resolve({ name: 'admin.areas-groups.create', query: { actAs: $route.query.actAs } }).href"
              target="_blank"
            ><i data-feather="plus" /></a>
            <a
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <CompleteTable
              :sorted-field="sortedField"
              :data="areas_data"
              :sort-mapping="sortMapping"
              :title="'areas and groups'"
              :total="totalAreas"
              :fetch-path="'areas/fetch'"
              :filter-path="'areas/filter'"
            >
              <template v-slot="{field}">
                <td class="text-end">
                  <span
                    class="dis-ib"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit area and group"
                  ><a
                    class="btn btn-icon rounded-circle btn-flat-dark"
                    :href="$router.resolve({ name: 'admin.areas-groups.edit', params: { id: field.id }, query: { actAs: $route.query.actAs } }).href"
                    target="_blank"
                  ><i data-feather="edit-3" /></a></span>
                  <span
                    class="dis-ib"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Delete area & group"
                    @click="showDeleteModal(field.id)"
                  ><a
                    href="#"
                    class="btn btn-icon rounded-circle btn-flat-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#modalDeleteWithInput"
                  ><i data-feather="trash-2" /></a></span>
                </td>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>
    <TableColumns />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TableColumns from '../../partials/offcanvas/TableColumns.vue'
import CompleteTable from '../../partials/components/CompleteTable.vue'

export default {
  components: {
    TableColumns,
    CompleteTable,
  },
  data() {
    return {
      sortedField: 'Order',
      defaultFields: [
        {
          name: 'Order',
          checked: true,
          order: 1,
        },
        {
          name: 'Name',
          checked: true,
          order: 2,
        },
        {
          name: 'Acronym',
          checked: true,
          order: 3,
        },
        {
          name: 'Parent',
          checked: true,
          order: 4,
        },
      ],
      sortMapping: {
        Order: 'table_order',
        Name: 'name',
        Acronym: 'code',
        Parent: 'parent.name',
      },
      areas_children: [],
    }
  },
  computed: {
    ...mapGetters({
      areas: 'areas/areas',
      totalAreas: 'areas/totalAreas',
      fields: 'modals/tableSettingsFields',
    }),
    areas_data() {
      let aux = []
      if (this.areas.length > 0) {
        this.areas.forEach(item => {
          aux = aux.concat([item].concat(item.childrens))
        })
      }
      return aux
    },
  },
  async mounted() {
    await this.$store.dispatch('areas/filter', this.$store.getters['filters/filters'])
    await this.$store.dispatch('modals/fetchUserFields', 'areas')
    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'areas',
      })
    }
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    async showDeleteModal(id) {
      await this.$store.dispatch('modals/saveDeleteData', { name: 'areas', url: `${Vue.prototype.$groupUrl}/areas/${id}` })
      this.$store.dispatch('modals/showDeleteModal', true)
    },
    openTableSettings() {
      this.$store.dispatch('modals/toggleTableSettings', true)
    },
  },
}
</script>
